import { useState } from 'react'
import { useFormsStore } from '../../../../stores/onboarding'
import { usePersonalStore } from '../../../../stores/personalInfo'
import { useInitializeStore } from '../../../../stores/initialize'
import Toast from 'react-native-toast-message'
import { globalStyles } from '../../../../static/styles/global'
import { ActivityIndicator, ScrollView, View, Text } from 'react-native'
import HomeDetailsHeader from '../../../home/HomeDetailsHeader'
import Card from '../../../shared/card/Card'
import CustomButton from '../../../shared/button/Button'
import Canvas from '../../../canvas'
import moment from 'moment'


const RonsHandBook = ({ navigation, route }: any) => {
    const { essUserOnBoardingKey, essUserOnBoardingFormKey, essFormKey } =
        route.params
    const { loading, postRonsHandBook } = useFormsStore()
    const [hasDrawn, setHasDrawn] = useState()
    const [signatureDataURL, setSignatureDataURL] = useState('')
    const personalstore = usePersonalStore()
    const intializestore = useInitializeStore()

    const data = {
        completeOnline: true,
        essUserKey: intializestore.initializeData.userkey,
        entityId: personalstore.personalData?.entityId,
        essUserOnBoardingFormKey: essUserOnBoardingFormKey,
        essObKey: essUserOnBoardingKey,
        sign: signatureDataURL
    }

    const handlesubmit = async () => {
        const response = await postRonsHandBook(data)
        if (response?.success) {
            await Toast.show({
                type: 'success',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60,
                onHide: () => {
                    navigation.replace('OnboardingForms')
                }
            })
        } else {
            await Toast.show({
                type: 'error',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60
            })
        }
    }

    return (
        <>
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel="Forms"
                        navScreen="OnboardingForms"
                        title="Rons Handbook"
                    />
                </View>
            </View>
            <ScrollView>
                <Card>
                    <Text
                        style={{ textAlign: 'center', fontSize: 25, fontWeight: 'bold' }}
                    >
                        Company Handbook
                    </Text>
                    <View style={[globalStyles.mt3]}>
                        <Text>
                            I have received instructions on how to access my company handbook
                            electronically and can request a paper copy at any time. I have
                            been instructed to read through the handbook and to keep it handy
                            for reference to company policies and disciplinary actions.
                        </Text>
                    </View>
                    <View style={[globalStyles.mt6]} >
                        <View style={[globalStyles.hDirection,]}>
                            <Text style={{ flex: 0.2 }}>
                                Print Name
                            </Text>
                            <Text style={{ borderBottomWidth: 1, }}>
                                {personalstore?.personalData?.firstName}{' '}
                                {personalstore?.personalData?.middleInitial}{' '}
                                {personalstore?.personalData?.lastName}
                            </Text>
                        </View>

                        <View style={[globalStyles.hDirection, globalStyles.mt2, globalStyles.vCenterItems]}>
                            <Text style={{ flex: 0.2, }}>Sign Name </Text>
                            <View style={{}}>
                                <Canvas
                                    setSignatureDataURL={setSignatureDataURL}
                                    setHasDrawn={setHasDrawn}
                                    hasDrawn={hasDrawn}
                                />
                            </View>
                        </View>
                        <View style={[globalStyles.hDirection, globalStyles.mt2]}>
                            <Text style={{ flex: 0.2 }}>Date  </Text>
                            <Text style={{ borderBottomWidth: 1, }}>{moment().format("MM/DD/YYYY")}</Text>
                        </View>
                    </View>
                </Card>
                {loading ? (
                    <ActivityIndicator />
                ) : (
                    <View
                        style={{
                            marginTop: 10,
                            marginBottom: 25,
                            flexDirection: 'row',
                            justifyContent: 'space-between'
                        }}
                    >
                        <CustomButton
                            text={'Previous'}
                            color={'warn'}
                            onPress={() => navigation.navigate('OnboardingForms')}
                        />
                        <CustomButton
                            isDisabled={!signatureDataURL || !hasDrawn}
                            text={'Submit'}
                            onPress={handlesubmit}
                        />
                    </View>
                )}
            </ScrollView>
        </>
    )
}

export default RonsHandBook
